import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, Form, Button, Table, Alert } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import OrderDetailModal from './OrderDetailModal';
import Select from "react-select";
import OrderDetailModalParent from './OrderDetailModalParent';
import moment from 'moment';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { useAppContext } from 'providers/AppProvider';
import SetMastersDetails from 'components/common/SetMastersDetails';
import Breadcrumb from 'components/doc-components/Breadcrumb';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import DatePicker from 'react-datepicker';
import RemoveMasters from 'components/common/RemoveMasters';
import TopSummaryBar from 'components/order-history/TopSummaryBar';
import paths from 'routes/paths';
import { storeList } from 'components/common/StoreList';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';

const OrderDetails = () => {
  const [refreshOrder, setRefreshOrder] = useState(false);
  const [facility, setFacility] = useState(null);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]); // Data from the API
  const [filteredData, setFilteredData] = useState([]); // Filtered data to display
  const [errorMessage, setErrorMessage] = useState(true);
  const [storeOptions] = useState([{ key: "Select Store", value: "" }, ...storeList]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [topData , setTopData] = useState({});
  const location = useLocation();
  const [title, setTitle] = useState('');
  const navigate = useNavigate();
  const [selectedStoreValue, setSelectedStoreValue] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const currentTitle = searchParams.get('id');
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, 'months').startOf('day').format('MM/DD/YYYY'),
    endDate: moment().endOf('day').format('MM/DD/YYYY'),
    patient: '',
    rxNumber: '',
    category: currentTitle || '',
    store: '',
    initiated: ''
  });
  const {
    config: { isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();
  const isFirstRender = useRef(true);
  const orderStatus = localStorage.getItem("order_status")
  ? JSON.parse(localStorage.getItem("order_status"))
  : {}; 
  const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
  const [options] = useState([
    { value: '', key: 'All' },
    ...facilityList
  ]);

  let facilityObj = facilityList.reduce((obj, item) => {
    obj[item.value] = item.key;
    return obj;
  }, {})

  const columns = [
    {
      accessorKey: 'patient',
      header: 'Patient',
      meta: {
        headerProps: { className: 'text-900 text-start px-2' },
        cellProps: { className: 'text-start px-2' }
      }
    },
    {
      accessorKey: 'facility',
      header: 'Facility',
      meta: {
        headerProps: { className: 'text-900 text-start px-2' },
        cellProps: { className: 'text-start px-2' }
      }
    },
    {
      accessorKey: 'ordertypetable',
      header: 'Order Type',
      meta: {
        headerProps: { className: 'text-900 text-center px-2' },
        cellProps: { className: 'text-center px-2' }
      }
    },
    {
      accessorKey: 'deliverydatetime',
      header: 'Delivery-Date',
      meta: {
        headerProps: { className: 'text-900 text-center px-2' },
        cellProps: { className: 'text-center fw-bold px-2' }
      }
    },
    {
      accessorKey: 'orderstatus',
      header: 'Order Status',
      meta: {
        headerProps: { className: 'text-900 text-center px-2' },
        cellProps: { className: 'text-center px-2' }
      },
      cell: ({ row: { original } }) => {
        const orderStatus = JSON.parse(localStorage.getItem("order_status"));
        return (
          <Link onClick={() => { setShow(true) }} state={{ original }}>
            {Number(original.is_pa) === 1
              ? "PA"
              : Number(original.is_billing_issue) === 1
              ? "Billing Issue"
              : Number(original.is_discarded) === 1
              ? "Discarded"
              : Number(original.is_loansupplies) === 1
              ? "Loan Supplies"
              : orderStatus[original.orderstatus]}

          </Link>
        )
      }
    },
    // {
    //   accessorKey: 'reason',
    //   header: 'Reason',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //     cellProps: { className: 'text-start' }
    //   }
    // },
    // {
    //   accessorKey: 'refillrequest',
    //   header: 'Refill Request',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //     cellProps: { className: 'text-start' }
    //   }
    // },
    {
      accessorKey: 'createddate',
      header: 'Created Date',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    // {
    //   accessorKey: 'moredetails',
    //   header: 'More Details',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //   },
    //   cell: () => {
    //     return (
    //       <FontAwesomeIcon icon="file" className="me-1 fs-11" />
    //     )
    //   }
    // },
  ]

  useEffect(() => {
      setTitle(currentTitle);
  }, []);

  const fetchTable = async () => {
    setIsLoading(true);
    setApiError(false);
    const searchParams = new URLSearchParams(location.search);
    let sendingObj = {
      from_date: searchParams.get('from') || filters.startDate,
      to_date: searchParams.get('to') || filters.endDate,
    }
    let tokenStr = localStorage.getItem("accessToken");
    try{
    const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/orders/list-orders/", sendingObj, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
    let orderType = JSON.parse(localStorage.getItem("order_types"));
    let objData = data.orders
    let results = []
    objData.map((iterator) => {
      results.push({
        patient: iterator.patient_lastname + ", " + iterator.patient_firstname,
        facility: facilityObj[iterator.facility_id],
        facilityid: iterator.facility_id,
        ordertype: iterator.order_type,
        ordertypetable: iterator.order_type == 9 ? "New Patient" : orderType[iterator.order_type],
        deliverydatetime: iterator.delivery_date != null ? moment(iterator.delivery_date).format('MM/DD/YY') : null,
        reason: iterator.discarded_reason,
        refillrequest: iterator.refill_request,
        createdby: iterator.created_by_username,
        createddate: iterator.created != null ? moment(iterator.created).format('MM/DD/YY - hh:mm A') : null,
        orderstatus: iterator.order_status,
        rxnumber: iterator.pharmacy_order_id,
        qty: iterator.drug_qty,
        drug: iterator.drug + " " + iterator.strength_value + " " + iterator.strength,
        orderid: iterator.id,
        notesObj: iterator.notes,
        documents : iterator.documents,
        internalNotesObj: iterator.internal_notes,
        is_billing_issue: iterator.is_billing_issue,
        is_loansupplies: iterator.is_loansupplies,
        is_pa: iterator.is_pa,
        flag: true,
        patientModalData: iterator.patient,
        order_status_log : iterator.logs,
        is_notified: iterator.is_notified,
        is_hold: iterator.is_hold,
        is_discarded: iterator.is_discarded,
        delivery_date: iterator.delivery_date,
        store_id: iterator.store_id,
        deliveryOn : iterator.delivery_type,
        pickup_store_id : iterator.pickup_store_id,
        billing_date: iterator.billing_date,
        billing_status  : iterator.billing_status,
        billing_timestamp : iterator.billing_timestamp,
        pv1_timestamp : iterator.pv1_timestamp,
        pv2_timestamp : iterator.pv2_timestamp,
        filling_timestamp : iterator.filling_timestamp,
      })
    })

    let filtered = results;
    let today = moment()
    
    if (currentTitle === 'due') {
      // filtered = results.filter((item) => moment(item.delivery_date).isAfter(today));
      filtered = results.filter((item) => Number(item.orderstatus) < 8 && moment(item.delivery_date, 'MM/DD/YYYY').isSameOrBefore(today, 'day'));
    } else if (currentTitle === 'billing') {
      filtered = results.filter((item) => Number(item.is_billing_issue) === 1);
    } else if (currentTitle === 'pa') {
      filtered = results.filter((item) => Number(item.is_pa) === 1);
    } else if (currentTitle === 'loan') {
      filtered = results.filter((item) => Number(item.is_loansupplies) === 1);
    } else if (currentTitle === 'hold') {
      filtered = results.filter((item) => Number(item.is_hold) === 1);
    } else if (currentTitle === 'mobile') {
      // check if orderstatus is 1 and is_pa is 0 and is_loansupplies is 0 and is_hold is 0 and is_billing_issue is 0 and is_discarded is 0
      filtered = results.filter((item) =>{
        if(item.orderstatus == 1 && Number(item.is_billing_issue) !== 1 && Number(item.is_discarded) !== 1 && Number(item.is_loansupplies) !== 1 && Number(item.is_pa) !== 1 && Number(item.is_hold) !== 1){
          return Number(item.orderstatus) === 1;
        }
      }) 

    } 

    setData(results);
    setFilteredData(filtered);
    setTopData(data.orders_status_count);
  } catch (error) {
    console.error('Error fetching data:', error);
    setApiError(true);
    toast.error("Failed to fetch order details.");
  } finally {
    setIsLoading(false);
  }
  }

  const searchByDate = async () => {
    try {
      fetchTable()
      clearFilters()
    } catch (error) {
      console.error('Error fetching data by date:', error);
      toast.error('Failed to fetch data by date');
    }
  };

  const table = useAdvanceTable({
    data: filteredData,
    columns,
    selection: false,
    sortable: true,
    pagination: true
  });

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterLocalData(filters);
  }, [filters]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterCategory(filters.category);
  }, [filters.category]);

  useEffect(() => {
    setConfig('isNavbarVerticalCollapsed', true);
    fetchData();

    return () => {
      setConfig('isNavbarVerticalCollapsed', false);
      RemoveMasters();
    }
  }, [refreshOrder]);



  const fetchData = async () => {
    try {
      SetMastersDetails();
      fetchTable();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Remove query params on any field change
    navigate(`${location.pathname}`);
    setFilters({
      ...filters,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFacilityInputChange = (selectedOption) => {
    setFacility(selectedOption);
    setFilters({
      ...filters,
      "facility_ID": selectedOption ? selectedOption.value : ''
    });
  }

  async function handleSearch(e) {
    e.preventDefault();
    if (filters.startDate && filters.endDate) {
      setTitle('');
      await searchByDate();
    }
  };


  const filterLocalData = (filters) => {
    const filtered = data.filter((item) => {
      return (
        (!filters.patient || item.patient.toLowerCase().includes(filters.patient.toLowerCase())) &&
        (!filters.rxNumber || item.rxnumber === Number(filters.rxNumber)) &&
        (!filters.category || item.orderstatus === Number(filters.category)) &&
        (!filters.facility_ID || item.facilityid === filters.facility_ID) &&
        (!filters.initiated || item.initiated === filters.initiated) &&
        (!filters.store || item.store_id === filters.store)
      );
    });
    // if (filtered.length) {
    //   setFacility(null);
    // }
    setFilteredData(filtered);
  };

  const filterCategory = (currentTitleCategory) => {
    let filtered = data;
    if (currentTitleCategory === 'discard') {
      filtered = data.filter((item) => Number(item.is_discarded) === 1);
    } else if (currentTitleCategory === 'billing') {
      filtered = data.filter((item) => Number(item.is_billing_issue) === 1);
    } else if (currentTitleCategory === 'mobile') {
      // check if orderstatus is 1 and is_pa is 0 and is_loansupplies is 0 and is_hold is 0 and is_billing_issue is 0 and is_discarded is 0
      filtered = data.filter((item) =>{
        if(item.orderstatus == 1 && Number(item.is_billing_issue) !== 1 && Number(item.is_discarded) !== 1 && Number(item.is_loansupplies) !== 1 && Number(item.is_pa) !== 1 && Number(item.is_hold) !== 1){
          return Number(item.orderstatus) === 1;
        }
      })      
    } else if (currentTitleCategory === 'pa') {
      filtered = data.filter((item) => Number(item.is_pa) === 1);
    } else if (currentTitleCategory === 'loan') {
      filtered = data.filter((item) => Number(item.is_loansupplies) === 1);
    } else if (currentTitleCategory === 'hold') {
      filtered = data.filter((item) => Number(item.is_hold) === 1);
    }else if (currentTitleCategory === 'done') {
      filtered = data.filter((item) => Number(item.orderstatus) === 9);
    }else if (currentTitleCategory === 'due') {
      const today = moment();
      
      
      filtered = data.filter((item) => Number(item.orderstatus) < 8 && moment(item.delivery_date, 'MM/DD/YYYY').isSameOrBefore(today, 'day'));

    }

    // const filtered = data.filter((item) => {})
      setFilteredData(filtered);
    // if (filtered.length) {
    // }
  }


  const validateExpiryDate = date => {
    if (moment(date) > moment(filters.startDate)) {
      handleInputChange({ target: { name: 'endDate', value: moment(date).format("MM/DD/YYYY") } })
    } else {
      toast.error("End date should be greater than Start Date");
    }
  }

  function toCapitalCase(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1) || '';
  }

  function clearFilters (){
    setFilters(prev => ({
      ...prev,
      patient: '',
      rxNumber: '',
      category: '',
      store: '',
      initiated: ''
    }));
    setSelectedStoreValue(null);
    setFacility(null);
    setTitle('');
  }

  const breadcrumbItems = [
    { name: 'Dashboard', href: '/main', isActive: false },
    { name: 'Order', href: '#', isActive: true },
    { name: 'Order List', href: "#", isActive: true }
  ];

  const handleStoreChange = (selectedOption) => {
    setFilters({
      ...filters,
      "store": selectedOption ? selectedOption.value : ''
    });
    setSelectedStoreValue(selectedOption);
  }

  return (
    <>

      <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
      <OrderDetailModalParent show={show} filteredData={filteredData} setRefresh={setFilteredData} handleClose={() => setShow(false)} setOrder={setRefreshOrder} />
      {/* <Card className="p-1 pt-3 pb-1">
        <Row>
          <TopSummaryBar stats={topData} />
        </Row>
      </Card> */}
      <Card className="p-3">
        <h4 className="mb-3">{toCapitalCase(currentTitle)} Order List</h4>
        <div className="border rounded p-3 pb-4 mb-4">
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Start Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"
                  selected={filters.startDate ? moment(filters.startDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    handleInputChange({ target: { name: 'startDate', value: moment(date).format("MM/DD/YYYY") } })
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>End Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"
                  selected={filters.endDate ? moment(filters.endDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    validateExpiryDate(date)
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md={4} className="d-flex align-items-end">
              <Button variant="primary" onClick={handleSearch} className="me-2">
                Search
              </Button>
            </Col>
          </Row>
        </div>
        <div className="filters-section border rounded pt-4 p-3 position-relative">
  <div className="filter-heading">Filters</div>
  
  <Row className="mb-3">

    <Col md={4}>
      <Form.Group>
        <Form.Label>Store</Form.Label>
        <ThemedSelect
          name="store"
          closeMenuOnSelect
          placeholder="Select store"
          classNamePrefix="react-select"
          options={storeOptions}
          value={selectedStoreValue}
          getOptionLabel={option => option.key}
          getOptionValue={option => option.value}
          onChange={handleStoreChange}
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? "#80bdff" : "#ced4da",
              boxShadow: "none",
              '&:hover': { borderColor: "#80bdff" },
              minHeight: "38px"
            }),
            option: (base, { isFocused, isSelected }) => ({
              ...base,
              backgroundColor: isSelected
                ? "#e9ecef"
                : isFocused
                ? "#f8f9fa"
                : "#fff",
              color: "#212529",
              cursor: "pointer"
            }),
            singleValue: base => ({
              ...base,
              color: "#212529"
            }),
            placeholder: base => ({
              ...base,
              color: "#6c757d"
            }),
            menu: base => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group>
        <Form.Label>Facility</Form.Label>
        <Select
          name="facility"
          closeMenuOnSelect
          placeholder="Select Facility"
          classNamePrefix="react-select"
          options={options}
          getOptionLabel={option => option.key}
          getOptionValue={option => option.value}
          onChange={handleFacilityInputChange}
          value={facility}
        />
      </Form.Group>
    </Col>


    <Col md={4}>
      <Form.Group>
        <Form.Label>Initiated</Form.Label>
        <Form.Select
          name="initiated"
          value={filters.initiated}
          onChange={handleInputChange}
        >
          <option value="">All</option>
          <option value="Pharmacy">Pharmacy</option>
          <option value="Facility">Facility</option>
        </Form.Select>
      </Form.Group>
    </Col>


  </Row>

  <Row className="g-3">


  <Col md={4}>
      <Form.Group>
        <Form.Label>Patient</Form.Label>
        <Form.Control
          type="text"
          name="patient"
          placeholder="Search by patient"
          value={filters.patient}
          onChange={handleInputChange}
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group>
        <Form.Label>Rx Number</Form.Label>
        <Form.Control
          type="text"
          name="rxNumber"
          placeholder="Search by Rx"
          value={filters.rxNumber}
          onChange={handleInputChange}
        />
      </Form.Group>
    </Col>


    <Col md={4}>
      <Form.Group>
        <Form.Label>Category</Form.Label>
        <Form.Select
          name="category"
          value={currentTitle || filters.category}
          onChange={handleInputChange}
        >
          <option value="">All</option>
          <option value="discard">Discarded Order</option>
          <option value="billing">Billing Issue</option>
          <option value="mobile">Mobile Order</option>
          <option value="pa">PA</option>
          <option value="loan">Loan Supplies</option>
          <option value="done">Done</option>
          <option value="due">Due</option>
        </Form.Select>
      </Form.Group>
    </Col>


  </Row>
</div>

      </Card>
      <br></br>
      {isLoading ? (
        <ShimmerUI />
      ) : apiError ? (
        <Alert variant="danger" className="text-center fw-bold">
          Failed to fetch order details. Please try again later.
        </Alert>
      ) : filteredData.length === 0 ? (
        <Alert variant="info" className="text-center fw-bold">
          No order details found for the selected date range.
        </Alert>
      ) : (
        <Card className="p-3">
          <AdvanceTableProvider {...table}>
            <Row>
              <Col xs="12">
                <AdvanceTable
                  headerClassName="bg-200 text-nowrap align-middle text-center"
                  rowClassName="text-nowrap align-middle text-center"
                  tableProps={{
                    size: 'sm',
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Card.Footer>
                <div className="mt-3">
                  <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                </div>
              </Card.Footer>
            </Row>
          </AdvanceTableProvider>
        </Card>
      )}
    </>
  );
};

export default OrderDetails;